'use client';

import Image, { ImageProps } from 'next/image';

export const ImageWithFallback = (props: ImageProps) => {
  return <Image onError={(e) => (e.currentTarget.style.visibility = 'hidden')} {...props} />;
};
